<footer class="footer">

  <!-- ── Layer 1: Main columns (5-col grid) ── -->
  <div class="footer__main">
    <div class="footer__main-inner">

      <!-- Col 1: Contacto -->
      <div class="footer__nav-col">
        <h3 class="footer__nav-heading">Contacto</h3>
        <ul class="footer__contact-list">
          <li class="footer__contact-item">
            <app-icon [icon]="mapPinIcon" [size]="16" />
            <span class="footer__contact-address">
              {{ contactInfo.address }}
              <span class="footer__map-links">
                <a
                  [href]="contactInfo.mapsUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="footer__map-link"
                  aria-label="Abrir en Google Maps"
                >
                  <img [src]="contactInfo.mapsLogo" alt="Google Maps" width="20" height="20" />
                </a>
                <a
                  [href]="contactInfo.wazeUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="footer__map-link"
                  aria-label="Abrir en Waze"
                >
                  <img [src]="contactInfo.wazeLogo" alt="Waze" width="20" height="20" />
                </a>
              </span>
            </span>
          </li>
          <li class="footer__contact-item">
            <app-icon [icon]="phoneIcon" [size]="16" />
            <a [href]="'tel:' + contactInfo.phone">{{ contactInfo.phone }}</a>
          </li>
          <li class="footer__contact-item">
            <app-icon [icon]="mailIcon" [size]="16" />
            <a [href]="'mailto:' + contactInfo.email">{{ contactInfo.email }}</a>
          </li>
          <li class="footer__contact-item">
            <app-icon [icon]="whatsappIcon" [size]="16" />
            <a [href]="contactInfo.whatsapp" target="_blank" rel="noopener noreferrer">WhatsApp</a>
          </li>
        </ul>
      </div>

      <!-- Col 2: Tienda -->
      <nav class="footer__nav-col" aria-label="Tienda">
        <h3 class="footer__nav-heading">Tienda</h3>
        <ul class="footer__nav-list">
          <li><a [routerLink]="'/tienda'" class="footer__nav-link">Catálogo</a></li>
          <li><a [routerLink]="'/tienda'" [queryParams]="{ filter: 'novedades' }" class="footer__nav-link">Novedades</a></li>
          <li><a [routerLink]="'/tienda'" [queryParams]="{ on_discount: true }" class="footer__nav-link">Ofertas</a></li>
          <li><a [routerLink]="'/tienda'" [queryParams]="{ sort: 'popular' }" class="footer__nav-link">Más vendidos</a></li>
          <li><a [routerLink]="'/tienda/precompras'" class="footer__nav-link">Precompras</a></li>
        </ul>
      </nav>

      <!-- Col 3: Brand + Newsletter (centro) -->
      <div class="footer__center">
        <a [routerLink]="'/'" class="footer__logo-link" aria-label="Perrón Store — inicio">
          <img
            ngSrc="/images/logo/logo.png"
            alt="Perrón Store"
            width="140"
            height="48"
            class="footer__logo"
          />
        </a>
        <p class="footer__tagline">Tu tienda TCG de confianza en Costa Rica.</p>

        <app-newsletter-form
          class="footer__newsletter-form"
          variant="footer"
          inputId="footer-email"
          placeholder="tu@correo.com"
          ctaLabel="Suscribirse"
          description="Recibe novedades y ofertas exclusivas"
        />
      </div>

      <!-- Col 4: Información -->
      <nav class="footer__nav-col" aria-label="Información">
        <h3 class="footer__nav-heading">Información</h3>
        <ul class="footer__nav-list">
          <li><a [routerLink]="'/nosotros'" class="footer__nav-link">Sobre nosotros</a></li>
          <li><a [routerLink]="'/eventos'" class="footer__nav-link">Eventos</a></li>
          <li><a [routerLink]="'/perron-coins'" class="footer__nav-link">{{ coinsCopy.NAV_LINK }}</a></li>
          <li><a [routerLink]="'/comunidad'" class="footer__nav-link">Comunidad</a></li>
          <li><a [routerLink]="'/contacto'" class="footer__nav-link">Contacto</a></li>
          <li><a [routerLink]="'/terminos-y-condiciones'" class="footer__nav-link">Términos y Condiciones</a></li>
          <li><a [routerLink]="'/privacidad'" class="footer__nav-link">Política de Privacidad</a></li>
          <li><a [routerLink]="'/cambios-y-devoluciones'" class="footer__nav-link">Cambios y Devoluciones</a></li>
          <li><a [routerLink]="'/envios'" class="footer__nav-link">Política de Envíos</a></li>
        </ul>
      </nav>

    </div>
  </div>

  <!-- ── Layer 2: Bottom bar ── -->
  <div class="footer__bottom">
    <div class="footer__bottom-inner">

      <!-- Left: Social icons -->
      <div class="footer__socials">
        <a href="https://www.facebook.com/profile.php?id=100072122377020" class="footer__social-link" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <app-icon [icon]="facebookIcon" [size]="18" />
        </a>
        <a href="https://instagram.com/perronstorecr" class="footer__social-link" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <app-icon [icon]="instagramIcon" [size]="18" />
        </a>
        <a href="https://www.tiktok.com/@perronstorecr" class="footer__social-link" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
          <app-icon [icon]="tiktokIcon" [size]="18" />
        </a>
        <a href="https://wa.me/50689125220" class="footer__social-link footer__social-link--whatsapp" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
          <app-icon [icon]="whatsappIcon" [size]="18" />
        </a>
      </div>

      <!-- Center: Copyright -->
      <p class="footer__copyright">
        &copy; {{ currentYear }} Perrón Store. Todos los derechos reservados.
      </p>

      <!-- Right: Payment badges -->
      <div class="footer__payments" aria-label="Métodos de pago aceptados">
        <span class="footer__payment-badge">VISA</span>
        <span class="footer__payment-badge">Mastercard</span>
        <span class="footer__payment-badge">SINPE Móvil</span>
        <span class="footer__payment-badge">Efectivo</span>
      </div>

    </div>
  </div>

</footer>
